import React, { useEffect, useRef, useState } from "react";
import { useUggRouting } from "@ugitgud/legos/context/routing";
import { useLocalStorage } from "@ugitgud/legos/hooks/useLocalStorage";
import { isBefore, subDays } from "date-fns";
import { useBanner } from "@ugitgud/legos/hooks/useBanner";

export const BannerContainer: React.FC<{
  ctaId: string;
  children: (props: { onClick: (url: string) => void; onClose: () => void }) => React.ReactElement;
}> = ({ children, ctaId }) => {
  const { push } = useUggRouting();
  const { open, setBannerDismissedDate } = useBanner(ctaId);

  if (!open) {
    return null;
  }

  return (
    <>
      {children({
        onClick: (url) => {
          push(url);
        },
        onClose: () => setBannerDismissedDate({ dismissedDate: new Date().toISOString() }),
      })}
    </>
  );
};
